/*
 * src/components/TransferSuccess/SuccessSecondRow.jsx
 * Description: second row for a transfer record
 * Copyright (c) 2021 PredictiveUX
 */

import React from 'react';
import get from 'lodash/get';

import arrow from '../../styles/assets/Arrow_right.svg';

const SuccessSecondRow = ({
  bankAccount,
  destAccount,
  bankAccountLogo,
  escrowAccountLogo,
  tenant,
  disbursement,
  transfer,
}) => {
  const tenantName = get(tenant, 'name');
  const address1 = get(tenant, 'address1');
  const address2 = get(tenant, 'address2');
  const city = get(tenant, 'city');
  const state = get(tenant, 'state');
  const zipcode = get(tenant, 'zipcode');
  const office = get(transfer, 'office.title');
  return (
    <div className='create-account__row'>
      <div className='row create-account__item-title-container'>
        <div className='col-xs-6 create-account__item-title'>From</div>
        <div className='col-xs-6 create-account__item-title-receiver'>To</div>
      </div>
      <div
        className={!disbursement ? `row` : `row create-account__flex-revers`}
      >
        <div className={`col-xs-5 create-account__item-text`}>
          <div className='create-account__bank-information'>
            <div className='create-account__bank-information-logo'>
              <img
                className='create-account__bank-information-icon-logo'
                src={bankAccountLogo}
                alt=''
              />
            </div>
            <div className="create-account__bank-information-account">
              {get(bankAccount, 'bankName')}
              <br />
              Account X
              {get(bankAccount, 'accountLastFourDigits')
                ? get(bankAccount, 'accountLastFourDigits')
                : ''}
            </div>
          </div>
        </div>
        <img
          className='create-account__destination-account-arrow-logo d-none d-lg-block'
          src={arrow}
          alt=''
        />
        <div className='col-xs-4 create-account__item-text'>
          <div className='create-account__bank-information'>
            <div className='create-account__bank-information-account'>
              {tenantName}
              <br />
              {address1}
              {address2 !== null ? (
                <>
                  <br />
                  {address2}
                </>
              ) : null}
              <br />
              {city}, {state} {zipcode}
              <br />
              {office}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SuccessSecondRow
